import { authorizationHeader } from 'lane-shared/helpers/formatters';
import makeFileDownload from './makeFileDownload';
import { GetAuthTokenResponse } from 'lane-shared/types/auth0/getAuthTokenResponseType';

export default async function downloadFile(
  url: string,
  getAuthToken: GetAuthTokenResponse,
  customFilename?: string,
  withNoHeaders?: boolean
) {
  const token = await getAuthToken();
  let response;

  if (withNoHeaders) {
    response = await fetch(url);
  } else {
    response = await fetch(url, {
      method: 'GET',
      headers: new Headers({ Authorization: authorizationHeader(token) }),
    });
  }

  const blob = await response.blob();
  const fileType = response.headers.get('content-type');
  const [, fileName] = (
    response.headers.get('content-disposition') || ''
  ).split('filename=');

  makeFileDownload({
    type: fileType || 'text',
    name: customFilename || fileName || 'download',
    blob,
  });
}
